export enum TrialStatus {
  FREE_TRIAL_STATUS_CURRENT = 'current',
  FREE_TRIAL_STATUS_NEVER_USED = 'never-used',
  FREE_TRIAL_STATUS_JUST_FINISHED = 'just-finished',
  FREE_TRIAL_STATUS_USED = 'used-before'
}
